module.exports = __webpack_public_path__ + "static/media/a-emporter.a2297d39.svg";